export const LayoutAdminCommon = {
    titleMenuSearch:"Thông tin tìm kiếm",
    buttonDeleteSearch: "Xóa lựa chọn",
    buttonSaveSearch: "Tìm kiếm",
    buttonSaveMainModal: "Lưu",
    buttonDeleteMainModal: "Xóa",
    buttonSaveCreateModal: "Lưu",
    buttonDeleteCreateModal: "Hủy",
}